var config = {
  notifications: {
    error: "An unexpected error has occurred.",
    productNotFound: "Product was not found.",
    loading: ""
  }
};
export default config;